
























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import App from '../../model/App'
import AppRelease from '@/modules/app-router/model/AppRelease';
import {State} from 'vuex-class';

/**
 * Selector de versión
 */
@Component
export default class AppReleaseSelect extends Vue {
    /**
     * Label mostrada encima del campo
     *
     * @var { string }
     */
    @Prop({type: String, default: 'Seleccionar distribución'})
    public label: string

    /**
     * Indica si el camp permite seleccionar varias versiones al mismo tiempo
     *
     * @var { boolean }
     */
    @Prop({type: Boolean, default: false})
    public multiple: boolean

    @Prop({type: String, default: '300px'})
    public width: string

    @State(state => state.appRouter ? state.appRouter.app : null)
    public app: App

    @Prop({type: AppRelease, default: null})
    public value: AppRelease | null

    @Prop({type: Boolean, default: false})
    public isReleaseParent: boolean

    /**
     * Auto seleccionar la versión marcada por defecto al crear el componente
     */
    @Prop({type: Boolean, default: false})
    public autoSelectDefault: boolean

    /**
     * Excluir deshabilitadas
     *
     * Si esta opción es activada el selector solo mostrará la lista de distribuciones
     * que no hayan sido desactivadas y sigan en funcionamiento.
     */
    @Prop({type: Boolean, default: false})
    public excludeDisabled: boolean

    /**
     * Muestra el selector de versión como un dialogo en la parte inferior de la pantalla
     */
    @Prop({type: Boolean, default: false})
    public bottomSheet: boolean

    /**
     * Controla la visibilidad del dialogo cuando se encuentra activa la opción
     * "bottomSheet"
     */
    @Prop({type: Boolean, default: false})
    public active: boolean

    public created () {
        this.autoSelectDefault && this.selectDefault()
    }

    public select (release: AppRelease) {
        this.$emit('input', release)
        this.$emit('update:active', false)
    }

    /**
     * Selecciona la versión marcada por defecto
     */
    public selectDefault () {
        const release = this.releases.filter(r => r.default)[0]
        if (!release) {
            return
        }

        this.$emit('input', release)
    }

    /**
     * Distribuciones de la app
     */
    public get releases () {
        if (!this.app) {
            return []
        }

        return this.app.releases
            .filter(release => !(this.excludeDisabled && !release.enabled))
            .reverse()
    }
}
